import isModal from './isModal';
import toUrl from './toUrl';
import Cookies from 'cookies-js';


export default function target(app, purchase_id) {
  var url = location.href;
  var purl = Cookies.get('purl');

  /*if (isModal() && purl) {
    if (Cookies.get('purl_only') === "1") {
      url = purl;
    } else {
      var params = {
        // se c'è il product_id devo aprire l'applicativo product
        product_id: app.product ? app.product.id : null,
        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
        user: !app.product ? true : null
      };
      url = toUrl(purl, params);
    }
  }*/

  var params = {
    // se c'è il product_id devo aprire l'applicativo product
    product_id: app.product ? app.product.id : null,
    // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
    user: !app.product ? true : null
  };
  
  if (purl) {
    url = toUrl(purl, params);
  }
  

  // fix paypal redirect
  /*if (url.indexOf('#') !== -1) {
    url = url.substring(0, url.indexOf('#'));
  }*/
  var url_replaced = url
  //redirect sulla thankyou page, la pagina di ritorno non è mai in modale, e se parto dallo user vado sulla prodotto 
  var lattice_id = app.lattice ? app.lattice.id : null
  const lattice_params = lattice_id ? "lattice=" + lattice_id : null
  if (isModal()) {
    const value = process.env.NODE_ENV === 'production' ? 'promo' : 'test'

    url_replaced = "https://" + value + ".madai.com/wa/ui/thankyou/" + purchase_id + '?' + lattice_params
  } else if (url.indexOf("/campaign") !== -1) {
    if (url.indexOf("?") == -1) {
      url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id + '?' + lattice_params)
    } else {
      url_replaced = url.substr(0, url.indexOf("/campaign")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&"+ lattice_params))
    }
  }
  else if (url.indexOf("/product") !== -1) {
    if (url.indexOf("?") == -1) {
      url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id + '?' + lattice_params)
    } else {
      url_replaced = url.substr(0, url.indexOf("/product")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&"+ lattice_params))
    }
  }  
  else if (url.indexOf("/user") !== -1) {
    if (url.indexOf("?") == -1) {
      url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id + '?' + lattice_params)
    } else {
      url_replaced = url.substr(0, url.indexOf("/user")).concat("/thankyou/" + purchase_id).concat(url.substr(url.indexOf("?"), url.length).concat("&"+ lattice_params))
    } 
  }
  return url_replaced;
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/target.js
 **/